/* eslint-disable no-param-reassign */
import React, { createContext } from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import LcpPreload from 'components/shared/LcpPreload'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

export const VacancyContext = createContext({
  title: '',
  location: '',
  details: [],
})

interface PageTemplateProps {
  data: {
    page: {
      path?: string
      title: string
      dateGmt?: string
      recap?: any
      seo: any
      flexContent: any
    }
  }
  location?: any
  prefix?: string
}

const PageTemplate: React.FC<PageTemplateProps> = ({
  data: {
    page: { title, dateGmt, recap, flexContent, seo },
  },
  location = {},
  prefix = 'Vacancy_Flexcontent',
}) => {
  if (seo) {
    seo.schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: location.origin,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: seo.title,
            item: location.href,
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'JobPosting',
        title,
        description: seo.metaDesc,
        datePosted: dateGmt,
        validThrough: new Date(new Date().setMonth(new Date().getMonth() + 3)),
        employmentType: 'FULL_TIME',
        hiringOrganization: {
          '@type': 'Organization',
          name: 'PFC',
          sameAs: 'https://www.pfc.nl',
          logo: 'https://www.pfc.nl/static/logo-512x512.png',
        },
        jobLocation: {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            streetAddress: recap?.location,
            addressLocality: 'Veenendaal',
            addressRegion: 'Utrecht',
            postalCode: '3903 LH',
            addressCountry: 'NL',
          },
        },
        baseSalary: {
          '@type': 'MonetaryAmount',
          currency: 'EUR',
          value: {
            '@type': 'QuantitativeValue',
            value: 'In overleg',
            unitText: 'MONTH',
          },
        },
      },
    ]
  }

  console.log(recap)

  return (
    <Layout>
      <SEO seo={seo} />
      <LcpPreload flexContent={flexContent} />
      <VacancyContext.Provider
        value={{
          title,
          location: recap?.location,
          details: recap?.details,
        }}
      >
        <FlexContentHandler
          prefix={prefix}
          fields={flexContent}
          location={location}
        />
      </VacancyContext.Provider>
    </Layout>
  )
}

export const pageQuery = graphql`
  query vacancyById($pageId: String!) {
    page: wpVacancy(id: { eq: $pageId }) {
      ...generalVacancyFragment
    }
  }
`

export default PageTemplate
